export const GET_SINGLE_ORDER = 'GET_SINGLE_ORDER';
export const RECEIVED_ORDERS = 'RECEIVED_ORDERS';
export const SET_ORDER = 'SET_ORDER';
export const CREATE_ORDER = 'CREATE_ORDER';
export const SET_PROPERTY_ORDER = 'SET_PROPERTY_ORDER';
export const DELETE_ORDER = 'DELETE_ORDER';
export const SET_PRODUCTS_ORDER = 'SET_PRODUCTS_ORDER';

